import angular from 'angular';
import SalesImportIntroController from './import-intro.controller';
import Routes from './import-intro.routes';

import './import-intro.styles.scss';

export default angular.module('autoboard.importIntro', [])
  .config(Routes)
  .controller('SalesImportIntroController', SalesImportIntroController)
  .name;
